import Client from './client';

export default class SimplePermissionChecks extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  getPermissionAndChecks(options = {}) {
    return this.makeRequest(`${this.host}/permission/checks`, options);
  }

  getPermissionAndChecksByOrganization(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/permission/checks`, options);
  }

}
